import { userByIdOptions } from "@dashboard/api/queryApi";
import { useQuery } from "@tanstack/react-query";
import { useJwt } from "common-frontend-components";

export default function useUser() {
    const userId = useJwt((store) => store.userId);

    const { data: user } = useQuery(userByIdOptions({ id: userId }));

    return user;
}
